import {Utils} from "../../utils";
import {HomeItemRenderer} from "./home-item-renderer"

export class NewsletterRenderer extends HomeItemRenderer{
	constructor(container: HTMLElement,isForMobile:boolean){
		super(container);
		this.isForMobile = isForMobile;
	}
	public render(){
		var entryHtml = document.createElement("div");
		entryHtml.id = "p_home_newsletter";
		entryHtml.innerHTML = `
<div class='_titleSmall _type'>NEWSLETTER</div>
<div class='_title headline1'>Bleiben Sie auf dem Laufenden!</div>
<div class='text1 _subtitle'>Die aktuellsten Infos rund um das Schauspielhaus Graz,
die Premieren, Ihr Ensemble und alles Wissenswerte erfahren
Sie in unserem wöchentlichen Newsletter. Einfach registrieren
und keine spannenden Veranstaltungen mehr verpassen!</div>
<button class='customButton'><a href="/service/newsletter/">Newsletter Abonnieren</a></button>`;
		this.renderContainer(this.isForMobile).appendChild(entryHtml);
	}
}